import { resetPills, resetKidneyLiver, resetConversion } from "./reset";

if ($("#dosage-calculator").length) {
  $("select").niceSelect();
  $("select").each(function () {
    getOptions(`${$(this).attr("id")}`);
  });
}

$("#dosage-calculator .accordion__btn.collapsed").on("click", function () {
  resetPills();
  resetKidneyLiver();
  resetConversion();
});

function getOptions(name) {
  const jqxhr = $.ajax({
    method: "GET",
    url: "/wp-json/calculator/values",
  })
    .done(function (response) {
      const values = response.values[name];
      let select = '<option data-display="Wybierz">Wybierz</option>';
      values.forEach((val) => {
        select += `<option value="${val}">${val}</option>`;
      });
      $(`#${name}`).html(select);
      $(`#${name}`).niceSelect("update");
      $(`#${name}-loader`).addClass("d-none");
    })
    .fail(function () {
      console.log("error");
    });
}
